import { OnInit, ChangeDetectorRef, Directive, inject } from '@angular/core';
import { SahredConstants } from '../../constants/Values';
import { defaultPaginationParameters } from '../../interfaces/shared-interfaces';
import { Logger } from '../../../../common';

@Directive()
export abstract class BaseComponent<T> implements OnInit {
  // Common properties
  cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  paginationResponse: any;
  page = SahredConstants.INITIAL_PAGE_INDEX;
  size = SahredConstants.INITIAL_PAGE_SIZE;
  request: any = defaultPaginationParameters;
  HandelRenderingDataMessage: string = 'Loading...';

  // Force derived classes to implement their own list method
  abstract list(filter?: boolean): void;

  ngOnInit(): void {
    this.resetPagination(); // Reset pagination when component is initialized
    this.list(true);
  }

  // Reset the pagination parameters to their default values
  resetPagination(): void {
    this.page = SahredConstants.INITIAL_PAGE_INDEX;
    this.size = SahredConstants.INITIAL_PAGE_SIZE;
    this.request = { ...defaultPaginationParameters }; // Reset request to default pagination parameters
  }

  // Common methods for pagination, search, etc.
  onPageChange(event: number): void {
    this.page = event;
    this.request.page = event;
    this.list(true);
    Logger.debug('page change happend', event);
  }

  onPageSizeChange(event: number): void {
    // const currentFirstItemIndex = (this.page - 1) * this.size;
    this.size = event;
    // this.page = Math.floor(currentFirstItemIndex / this.size) + 1;
    // this.request.page = this.page;
    this.request.pageSize = event;
    this.list(true);
    Logger.debug('change happend', event);
    Logger.debug('page happend', this.page, this.request.page);
  }

  onSearch(event: string): void {
    this.request.page = 1;
    this.request.SearchKeyword = event;
    this.list(true);
    Logger.debug('search change happend', event);
  }
}
